export default class Settings {
  static serverURL = "http://82.180.163.136:7777";
  static mediaURL = "http://82.180.163.136/media";
  static noImageURL = "http://82.180.163.136/media/TestImages/no_image.png";
  // static serverURL = "https://localhost:7261"

}